import { useInfiniteQuery } from '@tanstack/react-query';
import { get } from '../../api';
import convertToQueryParams from '../../utils/convertToQueryParams';

const PRODUCTS_API = 'inventory/products/';

export function useProductsInfiniteQuery(filters) {
  const { search, category, is_active, tags, ordering, size } = filters;

  return useInfiniteQuery({
    queryKey: ['products', { search, category, is_active, tags, ordering, size }],
    queryFn: async ({ pageParam }) => {
      const response = await get(
        `${PRODUCTS_API}${convertToQueryParams({
          search,
          category,
          is_active,
          tags,
          ordering,
          page: pageParam,
          size: size || 12,
        })}`
      );
      return response.data;
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage, _allPages, lastPageParam) =>
      lastPage?.next ? lastPageParam + 1 : undefined,
  });
}
